export default "__VITE_ASSET__CiQnu0tB__"